import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import {ArticleListItem} from "./ArticleListItem";
import { useHttp } from "../../hooks/use-http";
import { useParams } from 'react-router-dom';
import {LoadingArticleListItem} from "../../components/Extra/Loading/LoadingArticleListItem";
import {FilteredListHeader} from "../../components/Extra/FilteredListHeader";

const ArticleListContainer = styled.div`
    padding-right: 10px;
    & div:last-child {
        border-bottom: none;
    }
`;

export const ArticleList = () => {
    const {tagId, tagLabel} = useParams();
    const [articles, setArticles] = useState([]);
    
    const {isLoading, error, sendRequest: fetchArticles} = useHttp();

    useEffect(() => {
        let url = '/articles/list';
        if (tagId) {
            url = `/articles/list/tag/${tagId}`;
        }
        const transformResponse = (data) => {
            setArticles(data.payload?.articles ? data.payload.articles : []);
        };
        fetchArticles({url}, transformResponse);
    }, [tagId, tagLabel, fetchArticles]);

    return (
        <ArticleListContainer>
            {tagId && <FilteredListHeader title="Articles tagged with:" clearFilterLink="/articles/list" tagLabel={tagLabel} />}  
            {isLoading && Array.from({length: 5}).map((_, index) => <LoadingArticleListItem key={index} />)}
            {error && <p style={{color: "red"}}>{error}</p>}
            {!isLoading && articles.length > 0 && articles.map((article, index) => {
                return <ArticleListItem key={index} article={article} />
            })}
        </ArticleListContainer>
    );
};
